var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownRight = function SvgArrowDownRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.975 10.5c.29 0 .525-.234.525-.525v-5.25a.524.524 0 1 0-1.05 0v3.983L4.397 3.653a.525.525 0 0 0-.742.742l5.053 5.053-3.983.002a.524.524 0 1 0 0 1.05z"
  })));
};
export default SvgArrowDownRight;